import './Support.css';
import NavigationBar from '../../../components/navbar/NavigationBar'
import PageTitle from '../../../components/Page Title/PageTitle'
import discordLogo from '../../../assets/icons/discord-logo.png';


const Support = () => {
  const handleInviteClick = () => {
    window.location.href = 'https://discord.gg/BxPKjuEmhn';  
  }
  return (
    <div className="pagebackground">
      <NavigationBar></NavigationBar>
      <PageTitle title="Need help?"></PageTitle>
      <div className="pagebox">
        <div>
          <p className='supporttext'>We have a team of support staff ready to help out with your issues. Raise a ticket on the discord and wait for the response</p>
        </div>

        <div className='joindiscorddiv' onClick={handleInviteClick}>
          <img className='discordlogo' src={discordLogo} alt='discord logo'></img>
          <p className='joindiscordtext'>Join our discord!</p>
        </div>
      </div>
    </div>
  );
}
export default Support;


